class e{}class r extends e{validate(e){return!0}deserialize(e){return e}}export{e as ResponseHandler,r as SimpleTypeResponseHandler};
